export default [
    {
        path: '/listDeclaration',
        name: 'listDeclaration',
        component: () => import('@/views/menu/declaration/listDeclaration.vue'),
        meta: {
            pageTitle: 'لیست اعلان ها',
            action: 'show',
            resource: 'SegmentManager',
        },
    },
 {
        path: '/editAnnouncement/:id?',
        name: 'editAnnouncement',
        component: () => import('@/views/menu/declaration/editAnnouncement.vue'),
        meta: {
            pageTitle: 'ویرایش اعلان ها',
            action: 'show',
            resource: 'SegmentManager',
        },
    },
]
